<template>
  <div>
    <LogTable />
  </div>
</template>

<script>
    import  LogTable  from '@/components/backend/LogResults.vue'

    export default {
        name: 'Logs',
        components: {
            LogTable

        }
    }
</script>

<style scoped>

</style>
